<template>
  <div :class="$style.itemsContainer">
    <template v-if="host && host.name">
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('host') }}</div>
        <div :class="$style.itemText">{{ host.name }}</div>
      </div>
    </template>
    <template v-if="allowedPlayers">
      <hr v-if="host && host.name" :class="$style.itemDivider" />
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('allowed-players') }}</div>
        <div :class="$style.itemText">{{ allowedPlayers }}</div>
      </div>
    </template>
    <template v-if="groupLimit">
      <hr v-if="host && host.name || allowedPlayers" :class="$style.itemDivider" />
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('group-limit') }}</div>
        <div :class="$style.itemText">{{ groupLimit }}</div>
      </div>
    </template>
    <template v-if="playersJoined">
      <hr v-if="host && host.name || allowedPlayers || groupLimit" :class="$style.itemDivider" />
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('players') }}</div>
        <div :class="$style.itemText">{{ playersJoined }}</div>
      </div>
    </template>
    <template v-if="title">
      <hr v-if="host && host.name || allowedPlayers || groupLimit || playersJoined" :class="$style.itemDivider" />
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('title') }}</div>
        <div :class="$style.itemText">{{ title }}</div>
      </div>
    </template>
    <template v-if="discipline">
      <hr v-if="host && host.name || allowedPlayers || groupLimit || playersJoined || title" :class="$style.itemDivider" />
      <div :class="$style.item">
        <div :class="$style.itemLabel">{{ $t('discipline') }}</div>
        <div :class="$style.itemText">
          {{ $t(disciplineOptions.find((option) => option.selectionValue === discipline)?.label || "unknown") }}
        </div>
      </div>
    </template>
    <hr :class="$style.itemDivider" />
    <div :class="$style.item">
      <div :class="$style.itemLabel">{{ $t('read-phase') }}</div>
      <div :class="$style.itemText">{{ readingTime }}<span :class="$style.itemSubText">{{ $t("min") }}</span></div>
    </div>
    <hr :class="$style.itemDivider" />
    <div :class="$style.item">
      <div :class="$style.itemLabel">{{ $t('discuss-phase') }}</div>
      <div :class="$style.itemText">{{ discussionTime }}<span :class="$style.itemSubText">{{ $t("min") }}</span></div>
    </div>
  </div>
</template>

<script>
import styles from "@/css/GameDetailsBox.module.css";
import globalStyles from "@/css/global.module.css";
import { disciplineOptions } from "@/utils/data";

export default {
  components: {},
  name: "GameDetailsBox",
  props: {
    host: {
      type: Object,
      required: false,
      default: null,
    },
    allowedPlayers: {
      type: Number,
      required: false,
      default: null,
    },
    groupLimit: {
      type: Number,
      required: false,
      default: null,
    },
    playersJoined: {
      type: Number,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    discipline: {
      type: String,
      required: false,
      default: "",
    },
    discussionTime: {
      type: Number,
      required: true,
    },
    readingTime: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      disciplineOptions: disciplineOptions,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
